import React from "react";
import { FormattedMessage, injectIntl } from "react-intl";
import { Alert, Button, Modal, Spinner } from "react-bootstrap";

class StatsModal extends React.Component {
  render() {
    return (
      <Modal
        show={true}
        onHide={() => this.props.close()}
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header closeButton={!this.props.confirm}>
          <Modal.Title>
            {!this.props.confirm ? (
              <FormattedMessage id="Confirm" />
            ) : (
              <FormattedMessage id="Export.In.Progress" />
            )}
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          {!this.props.confirm && (
            <div className="text-justify">
              <Alert variant="danger">
                <FormattedMessage id="Stats.Warning.Export" />
              </Alert>
              <p>
                <FormattedMessage id="Stats.Confirm.Export" />
              </p>
            </div>
          )}

          {this.props.confirm && (
            <div className="text-center">
              <Spinner
                as="span"
                animation="border"
                size="sm"
                role="status"
                aria-hidden="true"
              />{" "}
              <FormattedMessage id="Plz.Wait" />
            </div>
          )}
        </Modal.Body>

        {!this.props.confirm && (
          <Modal.Footer>
            <Button variant="secondary" onClick={() => this.props.close()}>
              <FormattedMessage id="Cancel" />
            </Button>
            <Button
              variant="danger"
              onClick={() => {
                this.props.successCallback();
              }}
            >
              <FormattedMessage id="Confirm" />
            </Button>
          </Modal.Footer>
        )}
      </Modal>
    );
  }
}

export default injectIntl(StatsModal);
